// all project config
export const BASE_API = process.env.VUE_APP_BASE_API;
// export const BASE_API = 'http://aiyu.he';
// export const BASE_API = '/jiekou';
// export const BASE_API = 'https://pre.api.aiyu98.com';
// export const BASE_API = 'https://api.aiyu98.com';
export const default_img = 'http://aiyubar-test.oss-cn-shenzhen.aliyuncs.com/aiyu-merchant-app/static/images/96x96-2.png';